'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en = require('i2l?query=sporks!i18n-data/data/locales/en');

var _en2 = _interopRequireDefault(_en);

var _legacyI18nInit = require('../../internal/legacyI18nInit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Provider) {
  return Provider.register(_en2.default, {
    getLocales: _legacyI18nInit.getLangEnabledLocales
  });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/init/register/lazy/registerNumberFormatting.js
// module id = 138
// module chunks = 177 178